export default "__VITE_ASSET__d2e7a166__"